import {faUser} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {Alert, Container} from 'react-bootstrap';
import {withTranslation} from 'react-i18next';
import styled from 'styled-components';
import Error from '../../../common/components/Error/Error';
import Screen from '../../../common/components/layout/Screen';
import Metadata from '../../../common/components/Metadata';
import '../assets/style.scss';
import {withLoadedUser} from '../../../login/containers/AuthBase';
import {ROLES} from '../../../common/constants';
import ProfileMerchant from '../components/ProfileMerchant';
import ProfileUser from '../components/ProfileUser';
import ProfileCentral from '../components/ProfileCentral';

const Span = styled.span`
  font-family: 'Segoe UI Bold', sans-serif;
`;

class ProfileView extends Component {
  state = {
    showError: false,
    showSuccess: false,
  };

  showSuccess = () => {
    this.setState({showSuccess: true});
    setTimeout(() => {
      this.setState({showSuccess: false});
    }, 2500);
  };

  showError = () => {
    this.setState({showError: true});
    setTimeout(() => {
      this.setState({showError: false});
    }, 2500);
  };

  displayProfileContent = () => {
    const {currentUser} = this.props;
    if (currentUser.role === ROLES.MERCHANT) {
      return <ProfileMerchant showSuccess={this.showSuccess} showError={this.showError}/>;
    } else if (currentUser.role === ROLES.CENTRAL_PURCHASING) {
      return <ProfileCentral showSuccess={this.showSuccess} showError={this.showError}/>;
    } else {
      return <ProfileUser showSuccess={this.showSuccess} showError={this.showError}/>;
    }
  };

  render() {
    const {t} = this.props;
    const {showSuccess, showError} = this.state;

    return (
      <div className="profile-layout">
        <Screen
          header={<Metadata meta={t('meta')} title={t('profile.title')}/>}
          leftTitle={
            <>
              <FontAwesomeIcon icon={faUser} color={'rgb(201,0,95)'} />
              <Span className="route-name">{t('profile.title')}</Span>
            </>
          }>
          <Container fluid style={{paddingBottom: '33px'}}>

            {showError && <Error error={t('error')}/>}
            <Alert
              show={showSuccess}
              delay={2000}
              variant={'primary'}
              onClose={() => this.setState({showSuccess: false})}
            >
              {t('profile.updated')}
            </Alert>

            {this.displayProfileContent()}

          </Container>
        </Screen>
      </div>
    );
  }
}

ProfileView.propTypes = {
  t: PropTypes.func.isRequired,
  currentUser: PropTypes.shape({
    role: PropTypes.string.isRequired,
  }).isRequired,
};

export default compose(
  withTranslation('user'),
  withLoadedUser,
)(ProfileView);

